import { useDispatch } from "react-redux";
import { sendUpdateChatStatus } from "../store/ChatThunk";
import { updatedChatStatusReceived } from "../store/ChatSlice";
import { AppDispatch } from "../../../../core/store/store";

interface UseChatStatus {
	updateChatStatus: (chatStatus: "leaved" | "blocked" | "active", chatID: string, statusUserID1: string) => void;
}

export const useChatStatus = (): UseChatStatus => {
	const dispatch: AppDispatch = useDispatch();

	const updateChatStatus = (chatStatus: "leaved" | "blocked" | "active", chatID: string, statusUserID1: string) => {
		dispatch(
			sendUpdateChatStatus({
				params: {
					chat_id: chatID,
					status: chatStatus,
				},
			})
		);
		dispatch(
			updatedChatStatusReceived({
				id: chatID,
				status_user_id1: chatStatus,
				status_user_id2: statusUserID1,
			})
		);
	};

	return {
		updateChatStatus,
	};
};
